import React from 'react';

const Warning = () => <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M10 2C5.584 2 2 5.584 2 10C2 14.416 5.584 18 10 18C14.416 18 18 14.416 18 10C18 5.584 14.416 2 10 2ZM11 14H9V12H11V14ZM11 11H9V6H11V11Z" fill="#DC3545"/>
</svg>


export default Warning;
